// Import des images
import uspManager from "../../assets/usp-manager.webp";
import pbernard from "../../assets/pbernard.webp";
import histoireMagique from "../../assets/histoire-magique.webp";

const data = [
  {
    portId: 19,
    category: "Exchange 2019",
    img: uspManager,
    title: "Zero Trust & Messagerie d'entreprise",
    desc: "Déploiement complet d'Exchange 2019 on-premise intégré à Active Directory. Sécurisation Zero Trust via AD FS et Cisco Duo MFA. Contournement du blocage port 25 FAI via relais SMTP sur VPS. Isolation du serveur mail derrière un VPN WireGuard hub-and-spoke avec DNS split-brain.",
    link: "https://github.com/edris-hub/MS-Excchange-AD-AD-FS-WireGuard.",
    // github: "",
  },
  {
    portId: 20,
    category: "Cisco Lab",
    img: pbernard,
    title: "Cisco Infrastructure Lab",
    desc: "Lab réseau Cisco physique — segmentation en 5 VLANs sur 5 switchs, routage inter-VLAN Router-on-a-Stick, redondance HSRP (R1 prio 150 / R2 prio 100), agrégation de liens EtherChannel LACP, relais DHCP et hardening SSH. 10 tâches livrées, toutes documentées.",
    link: "https://github.com/edris-hub/Cisco-infrastructure-lab",
    // github: "",
  },
  {
    portId: 21,
    category: "Home-Lab 90 Jours",
    img: histoireMagique,
    title: "Infrastructure Entreprise",
    desc: "Lab d'infrastructure entreprise structuré sur 90 jours : OPNsense Default-Deny, Active Directory, Keycloak SSO, automatisation Ansible, supervision Zabbix/Grafana, PKI via HAProxy, Veeam backup, GLPI ticketing. Chaque semaine produit un livrable versionné sur Git.",
    link: "https://github.com/edris-hub/homelab-infrastructure",
    // github: "",
  },
];

export default data;
